import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "cinema__list-item-alternative"
};
const _hoisted_2 = {
  class: "icon"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({
    'cinema__list-item-info': true
  })
};
import { computed, ref } from 'vue';
import { openCinemaSeries, openPopMenu, openPopModifyNFO } from '@remote/utils/dialog';
import fallback from '@shared/assets/img/cinema-fallback-icon.png';
import { store } from '@remote/store';
import { stat } from '@remote/utils/stat';
import { openPopCinemaFeedback } from '@remote/utils/dialog';
import { useDeviceStore } from '@remote/store/device';
import { toast } from '@remote/utils';
import debounce from 'lodash/debounce';
import { formatSize } from '@shared/utils/bytes';
import { SECOND } from '@shared/constants/time';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaListItem',
  props: {
    nfo: {
      type: Object,
      required: true
    },
    clickFrom: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const imgNodeRef = ref(null);
    const deviceStore = useDeviceStore();
    const loadFallback = () => {
      if (imgNodeRef.value) {
        imgNodeRef.value.src = fallback;
      }
    };
    const nfoClass = computed(() => {
      var _props$nfo$scrape_res;
      return (_props$nfo$scrape_res = props.nfo.scrape_result) === null || _props$nfo$scrape_res === void 0 ? void 0 : _props$nfo$scrape_res.class;
    });
    const reduceFilename = filename => {
      return filename.replace(/([【].*?)(www\.[a-zA-Z0-9.]+)(.*?|】\])|(www\.[a-zA-Z0-9.]+)/, '...');
    };
    const nfoName = computed(() => {
      var _props$nfo$scrape_res2, _props$nfo$scrape_res4, _name;
      let name;
      if ((_props$nfo$scrape_res2 = props.nfo.scrape_result) !== null && _props$nfo$scrape_res2 !== void 0 && _props$nfo$scrape_res2.short_name) {
        var _props$nfo$scrape_res3;
        // 如果有short_name，优先使用short_name
        name = (_props$nfo$scrape_res3 = props.nfo.scrape_result) === null || _props$nfo$scrape_res3 === void 0 ? void 0 : _props$nfo$scrape_res3.short_name;
      } else if (!['other', undefined].includes((_props$nfo$scrape_res4 = props.nfo.scrape_result) === null || _props$nfo$scrape_res4 === void 0 ? void 0 : _props$nfo$scrape_res4.class)) {
        var _props$nfo$scrape_res5;
        // 如果分类不是其他（刮削有结果），使用刮削出来的中文名
        name = (_props$nfo$scrape_res5 = props.nfo.scrape_result) === null || _props$nfo$scrape_res5 === void 0 ? void 0 : _props$nfo$scrape_res5.trans_name;
      } else {
        var _props$nfo$video_info;
        // 如果分类是其他（刮削没有结果），使用文件本身的名字
        name = (_props$nfo$video_info = props.nfo.video_info) === null || _props$nfo$video_info === void 0 ? void 0 : _props$nfo$video_info.file_name;
      }
      return reduceFilename((_name = name) !== null && _name !== void 0 ? _name : ''); // 对要展示的名字进行缩略
    });

    const handleClick = debounce(async () => {
      var _props$nfo$video_info2, _scrapeResult$dramas, _scrapeResult$dramas$, _scrapeResult$dramas2;
      const scrapeResult = props.nfo.scrape_result;
      stat({
        action: 'cinema_video_card_click',
        data: {
          tab_type: props.clickFrom,
          scraper_name: scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.trans_name,
          origin_name: (_props$nfo$video_info2 = props.nfo.video_info) === null || _props$nfo$video_info2 === void 0 ? void 0 : _props$nfo$video_info2.file_name,
          scraper_type: scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.class,
          tele_episode_num: ((_scrapeResult$dramas = scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.dramas) !== null && _scrapeResult$dramas !== void 0 ? _scrapeResult$dramas : []).length
        }
      });
      if ((scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.class) === 'tv' || (scrapeResult === null || scrapeResult === void 0 ? void 0 : scrapeResult.class) === 'movie' && ((_scrapeResult$dramas$ = (_scrapeResult$dramas2 = scrapeResult.dramas) === null || _scrapeResult$dramas2 === void 0 ? void 0 : _scrapeResult$dramas2.length) !== null && _scrapeResult$dramas$ !== void 0 ? _scrapeResult$dramas$ : 1) > 1) {
        // 如果是连续剧，展示右侧栏
        openCinemaSeries({
          nfo: props.nfo
        });
      } else {
        // 如果不是连续剧，直接播放
        try {
          var _props$nfo$video_info3;
          await store.dispatch('getFileInfo', {
            id: (_props$nfo$video_info3 = props.nfo.video_info) === null || _props$nfo$video_info3 === void 0 ? void 0 : _props$nfo$video_info3.file_id,
            usage: 2,
            theme: 'dark',
            scene: 'nfo',
            action_from: 'cinema'
          });
        } catch (error) {
          if (error.error === 'file_not_found' || error.error_description === 'file_not_found' || error.error === 'not_found') {
            var _deviceStore$currentN;
            (_deviceStore$currentN = deviceStore.currentNFOInstance) === null || _deviceStore$currentN === void 0 ? void 0 : _deviceStore$currentN.refreshAllList();
          }
          toast('播放失败，请检查文件是否存在');
        }
      }
    }, 500, {
      leading: true,
      trailing: false
    });
    const labels = computed(() => {
      var _deviceStore$currentD, _deviceStore$currentD2;
      return (_deviceStore$currentD = (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.deviceInfoRef.labels) !== null && _deviceStore$currentD !== void 0 ? _deviceStore$currentD : [];
    });
    const getOriginStatName = () => {
      var _store$state$deviceIn, _props$nfo$scrape_res6, _props$nfo$video_info5;
      const separator = (_store$state$deviceIn = store.state.deviceInfoWatchData.path_separator) !== null && _store$state$deviceIn !== void 0 ? _store$state$deviceIn : '/';
      if (((_props$nfo$scrape_res6 = props.nfo.scrape_result) === null || _props$nfo$scrape_res6 === void 0 ? void 0 : _props$nfo$scrape_res6.class) === 'tv') {
        var _props$nfo$video_info4;
        return (_props$nfo$video_info4 = props.nfo.video_info) === null || _props$nfo$video_info4 === void 0 ? void 0 : _props$nfo$video_info4.real_path.split(separator).slice(-2).join(separator);
      }
      return (_props$nfo$video_info5 = props.nfo.video_info) === null || _props$nfo$video_info5 === void 0 ? void 0 : _props$nfo$video_info5.file_name;
    };
    const modifyTime = computed(() => {
      var _props$nfo$video_info6, _props$nfo$video_info7;
      const date = new Date(((_props$nfo$video_info6 = (_props$nfo$video_info7 = props.nfo.video_info) === null || _props$nfo$video_info7 === void 0 ? void 0 : _props$nfo$video_info7.mod_time) !== null && _props$nfo$video_info6 !== void 0 ? _props$nfo$video_info6 : 0) * SECOND);
      return date.toLocaleString();
    });
    const fileSize = computed(() => {
      var _props$nfo$video_info8;
      return formatSize((_props$nfo$video_info8 = props.nfo.video_info) === null || _props$nfo$video_info8 === void 0 ? void 0 : _props$nfo$video_info8.file_size);
    });
    const menuClickStat = clickid => {
      var _props$nfo$scrape_res7, _props$nfo$scrape_res8, _ref, _props$nfo$scrape_res9, _props$nfo$scrape_res10, _props$nfo$scrape_res11, _props$nfo$scrape_res12;
      stat({
        action: 'cinema_video_option_click',
        data: {
          click_id: clickid,
          scraper_name: (_props$nfo$scrape_res7 = props.nfo.scrape_result) === null || _props$nfo$scrape_res7 === void 0 ? void 0 : _props$nfo$scrape_res7.trans_name,
          origin_name: getOriginStatName(),
          movie_episode_num: ((_props$nfo$scrape_res8 = props.nfo.scrape_result) === null || _props$nfo$scrape_res8 === void 0 ? void 0 : _props$nfo$scrape_res8.class) === 'movie' ? (_ref = (_props$nfo$scrape_res9 = props.nfo.scrape_result.dramas) !== null && _props$nfo$scrape_res9 !== void 0 ? _props$nfo$scrape_res9 : []) === null || _ref === void 0 ? void 0 : _ref.length : 'not_movie',
          tele_episode_num: ((_props$nfo$scrape_res10 = props.nfo.scrape_result) === null || _props$nfo$scrape_res10 === void 0 ? void 0 : _props$nfo$scrape_res10.class) === 'tv' ? ((_props$nfo$scrape_res11 = (_props$nfo$scrape_res12 = props.nfo.scrape_result) === null || _props$nfo$scrape_res12 === void 0 ? void 0 : _props$nfo$scrape_res12.dramas) !== null && _props$nfo$scrape_res11 !== void 0 ? _props$nfo$scrape_res11 : []).length : 'not_tv'
        }
      });
    };
    const onLongPress = async () => {
      try {
        var _props$nfo$scrape_res13;
        const isModifyNFOEnabled = labels.value.includes('withUserResetScrapeResult');
        const menu = ['删除'];
        if (isModifyNFOEnabled) menu.push('修改信息');
        if (((_props$nfo$scrape_res13 = props.nfo.scrape_result) === null || _props$nfo$scrape_res13 === void 0 ? void 0 : _props$nfo$scrape_res13.class) !== 'other') menu.push('错误反馈');
        const res = await openPopMenu({
          options: menu
        });
        if (res === '删除') {
          var _deviceStore$currentN2;
          menuClickStat('delete');
          await ((_deviceStore$currentN2 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN2 === void 0 ? void 0 : _deviceStore$currentN2.confirmDeleteNFO(props.nfo));
        } else if (res === '错误反馈') {
          menuClickStat('feedback_error');
          openPopCinemaFeedback({
            nfo: props.nfo
          });
        } else if (res === '修改信息') {
          var _props$nfo$scrape_res14, _props$nfo$scrape_res15;
          menuClickStat('modify');
          let modifyingDramas = (_props$nfo$scrape_res14 = (_props$nfo$scrape_res15 = props.nfo.scrape_result) === null || _props$nfo$scrape_res15 === void 0 ? void 0 : _props$nfo$scrape_res15.dramas) !== null && _props$nfo$scrape_res14 !== void 0 ? _props$nfo$scrape_res14 : [];
          if (modifyingDramas.length === 0 && props.nfo.video_info) {
            // 如果单集，且dramas为空，把video_info放进来
            modifyingDramas.push(props.nfo.video_info);
          }
          openPopModifyNFO({
            nfo: props.nfo,
            modifyingDramas
          });
        }
      } catch (error) {
        console.error(error);
        toast(error.message || error.error || '未知错误');
      }
    };
    return (_ctx, _cache) => {
      var _props$nfo$scrape_re, _props$nfo$scrape_re2;
      const _directive_longpress = _resolveDirective("longpress");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "cinema__list-item",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(handleClick) && _unref(handleClick)(...args)),
        onContextmenu: _cache[1] || (_cache[1] = e => {
          e.preventDefault();
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        ref_key: "imgNodeRef",
        ref: imgNodeRef,
        src: (_props$nfo$scrape_re = (_props$nfo$scrape_re2 = __props.nfo.scrape_result) === null || _props$nfo$scrape_re2 === void 0 ? void 0 : _props$nfo$scrape_re2.poster_vertical) !== null && _props$nfo$scrape_re !== void 0 ? _props$nfo$scrape_re : '',
        draggable: "false",
        onError: loadFallback
      }, null, 40, _hoisted_3)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(nfoName.value), 1), _createElementVNode("p", null, _toDisplayString(modifyTime.value) + " " + _toDisplayString(fileSize.value), 1)])], 32)), [[_directive_longpress, onLongPress]]);
    };
  }
});